import downloadcsv from '../Images/csv.png';
import uploadcsv from '../Images/upload.png';
import clone from '../Images/clone.png';

let data = {
    downloadcsv,
    uploadcsv,
    clone
}
export default data;